import { SxProps } from '@mui/material';
import React from 'react';
import { ActionType } from '@/constant/button';
import AngleBracketIcon from '@/public/icons/angle_bracket_right.svg';
import {
  PageText,
  PaginationButton,
  PaginationContainer,
} from '@/components/Home/@components/Pagination/styles';
import classNames from 'classnames';

export type PaginationProps = {
  readonly isLoop: boolean;
  readonly totalPage: number;
  readonly currentPage: number;
  readonly onClickPrev?: (page: number, action: ActionType.PREV) => void;
  readonly onClickNext?: (page: number, action: ActionType.NEXT) => void;
  readonly onPageChange?: (page: number) => void;
  readonly disabled?: boolean;
  readonly designType?: 'normal' | 'frosted';
  readonly sx?: SxProps;
};

const Pagination = ({
  isLoop,
  totalPage,
  currentPage,
  onClickPrev,
  onClickNext,
  onPageChange,
  disabled = false,
  designType = 'normal',
  sx,
}: PaginationProps) => {
  const isDisabled = totalPage === 1 || disabled;

  const handlePrev = () => {
    const prevPage = currentPage - 1;
    let nextPage = prevPage;
    if (prevPage < 1) nextPage = totalPage;

    onClickPrev?.(nextPage, ActionType.PREV);
    onPageChange?.(nextPage);
  };
  const handleNext = () => {
    const prevPage = currentPage + 1;
    let nextPage = prevPage;
    if (prevPage > totalPage) nextPage = 1;

    onClickNext?.(nextPage, ActionType.NEXT);
    onPageChange?.(nextPage);
  };

  return (
    <>
      <PaginationContainer className={classNames(designType)} sx={sx}>
        <PaginationButton
          disabled={isDisabled || (!isLoop && currentPage === 1)}
          onClick={handlePrev}
          disableRipple
          sx={{ transform: 'rotate(-180deg)' }}
        >
          <AngleBracketIcon />
        </PaginationButton>
        <PageText>
          <span className={'curr-page'}>{currentPage}</span> / {totalPage}
        </PageText>
        <PaginationButton
          disabled={isDisabled || (!isLoop && currentPage === totalPage)}
          onClick={handleNext}
          disableRipple
        >
          <AngleBracketIcon />
        </PaginationButton>
      </PaginationContainer>
    </>
  );
};

export default Pagination;
